export default __webpack_public_path__ + "static/media/construction-concept-with-engineering-tools.7e5ab672.jpg";